import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { getAccountScopeUserSettings } from 'owa-session-store';
import { toggleLocalKeytipsEnabledStatusMutator } from '../mutators/toggleLocalKeytipsEnabledStatus';

export const initializeKeytipsEnabledStatus = (): void => {
    const primeSettings = getAccountScopeUserSettings(
        getGlobalSettingsAccountMailboxInfo()
    )?.PrimeSettings;

    const keytipsSettings = primeSettings?.Items?.filter(
        item => item.Id === 'Ribbon_ShowKeytips'
    ).map(item => item.Value?.[0]?.value)[0];

    toggleLocalKeytipsEnabledStatusMutator(
        keytipsSettings == undefined || keytipsSettings === 'true'
    );
};
